module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.videoFile) ? _c('video', {
    staticClass: "video-component",
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoFile,
      "type": "video/mp4"
    }
  })]) : _c('iframe', {
    staticClass: "video-component",
    attrs: {
      "type": "text/html",
      "src": _vm.video_source,
      "allowFullScreen": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc49ab8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/video_component.vue
// module id = 613
// module chunks = 1